import 'slick-carousel'
import SLIDER from '../class/slider'

const[ w, d ] = [ window, document ];

const init = () => {

  const facilitySlider = new SLIDER({
    obj: '[data-plugin="slider"]',
    animationDuration: 3600,
    slickOpt: {
      autoplay: true,
      autoplaySpeed: 2600,
      speed: 1000,
      arrows: false,
      dots: true,
      variableWidth: true,
      centerMode: true,
      centerPadding: '25vw',
      slideToShow: 3,
      infinite: true,
      cssEase: 'ease-in-out',
      waitForAnimate: false,
      focusOnSelect: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      responsive: [{
        breakpoint: 900,
        settings: {
          centerPadding: '12.5vw',
        }
      }]
    }
  });

  $.when( w.load['company03'] ).then(() => {
    facilitySlider.init(), facilitySlider.start();
  });
}

export default function COMPANY() {
  $(init)
}